import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { getManifest, loadRemoteModule } from '@angular-architects/module-federation';
import { CustomManifest, CustomRemoteConfig } from '../utils/config';
import { RouteService as MenuService } from '@dexio/common';
import { ProjectsService } from './projects.service';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectLoaderService implements OnDestroy {

  remotes: CustomRemoteConfig[] = [];
  private projectSubscription = new Subscription();

  constructor(
    private router: Router,
    private readonly projectService: ProjectsService,
    private readonly menuService: MenuService
  ) {}

  async load(): Promise<void> {

    const manifest = getManifest<CustomManifest>();
    this.projectSubscription = this.projectService.getProjects().subscribe(projects => {
      
      let mainProjectRoute = this.router.config.find(_ => _.path == 'projects');
      if (mainProjectRoute == null) { console.error('No project parent route was found');}
      else {
        mainProjectRoute.children = [];
        this.router.resetConfig(this.router.config);
      }
      Object.keys(manifest).map(async key => {
        const entry = manifest[key];
        if (projects.filter((_: any) => _.name == entry.displayName).length > 0) {
          const serviceFactory = await loadRemoteModule({
                                      type: 'manifest',
                                      remoteName: key,
                                      exposedModule: entry.exposedRouteService
                                  });
                                  
          const routeService = serviceFactory[entry.exposedRouteService.replace('./','')];
          var projectroutes = new routeService().get();
          projectroutes.forEach((projectRoute: any) => {
            projectRoute.path = '/projects/' + projectRoute.path;
            console.log('Adding ' + projectRoute.path + ' to the menu');
            this.menuService.add(projectRoute);
            
            mainProjectRoute = this.router.config.find(_ => _.path == 'projects');
            if ((mainProjectRoute?.children ?? []).filter(_ => _.path == entry.routePath).length < 1) {
              mainProjectRoute?.children?.push({
                path: entry.routePath,
                loadChildren: () => loadRemoteModule({
                                        type: 'manifest',
                                        remoteName: key,
                                        exposedModule: entry.exposedModule
                                    }).then(m => m[entry.ngModuleName])
              });
              this.router.resetConfig(this.router.config);
            }
          });
        }
      });
    });

  }
  ngOnDestroy(): void {
    if (this.projectSubscription) { this.projectSubscription.unsubscribe(); }
  }
}
